module.exports = __webpack_public_path__ + "media/images/tutorial_header_pc1-02-5fdcae1ba67c80d2ebfc4d6d88e98ae4.png";